// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ac9b7e2a","823":"50deb1a7"}[chunkId] + ".chunk.js";
};